export const EVENT_TYPE = {
    NONE: '',
    CLOCK_IN: 'clock in',
    CLOCK_OUT: 'clock out',
    SICK: 'sick',
    NOTE: 'note',
    COMPED_SERVICE: 'comped service',
};
